import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';

import * as styles from './Page404.module.scss';
import Icon from 'components/UI/Icon';

import usePageBasicData from 'hooks/graphql/usePageBasicData';
import useReusableBlocks from 'hooks/graphql/useReusableBlocks';

const Page404 = () => {
  const {
    node: { uri },
  } = usePageBasicData('Homepage');

  const {
    forms_ui: {
      buttons: { goToHomePage },
    },
  } = useReusableBlocks();

  return (
    <div className={classnames('cr-wrap', styles.wrap)}>
      <div className={styles.inner}>
        <h2 className="cr-h2">This page isn't available</h2>
        <p className={classnames('cr-lead', styles.text)}>
          The page you looking for couldn't be found
        </p>
        <p>
          <Link
            to={uri}
            className={classnames(
              styles.link,
              'cr-btn cr-btn--large cr-btn--wide cr-btn--icon cr-btn--icon-red-txt'
            )}
          >
            {goToHomePage}
            <Icon name="corner-arrow-small-bold" />
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Page404;
